// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../../types/schema';

import { EntityValuationActions_EntityFragment } from '../../../../../../entities/details/EntityValuation/graphql/EntityValuation.generated';
import { gql } from '@apollo/client';
import { EntityValuationActions_EntityFragmentDoc } from '../../../../../../entities/details/EntityValuation/graphql/EntityValuation.generated';
export type AllEntitiesSlide_EntityFragment = (
  { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, onboardingEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null, household: { __typename?: 'Household', id: string }, subtype: { __typename?: 'CCorpBusinessEntity', grantorControlledValue: CurrencyUSD, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'CLTTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'CRTTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'CustodialPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'DonorAdvisedFund', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'GPBusinessEntity', grantorControlledValue: CurrencyUSD, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'GRATTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'ILITTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'IndividualPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'InsurancePersonalAccount', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'IrrevocableTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'JointPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'LLCBusinessEntity', grantorControlledValue: CurrencyUSD, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'LPBusinessEntity', grantorControlledValue: CurrencyUSD, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'PrivateFoundation', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'QPRTTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'RetirementPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'RevocableTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'SCorpBusinessEntity', grantorControlledValue: CurrencyUSD, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'SLATTrust', inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', grantorControlledValue: CurrencyUSD, id: string, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, displayName: string } }
  & EntityValuationActions_EntityFragment
);

export const Operations = {
  Fragment: {
    AllEntitiesSlide_Entity: 'AllEntitiesSlide_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AllEntitiesSlide_EntityFragmentDoc = gql`
    fragment AllEntitiesSlide_Entity on Entity {
  ...EntityValuationActions_Entity
  id
  kind
  stage
  onboardingEntitySuggestion {
    id
  }
  household {
    id
  }
  subtype {
    id
    currentValue
    mostRecentValuationDate
    displayName
    ... on GRATTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on ILITTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on RevocableTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on SLATTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on IrrevocableTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on QPRTTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on IndividualPersonalAccount {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on JointPersonalAccount {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on RetirementPersonalAccount {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on CustodialPersonalAccount {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on QualifiedTuitionPersonalAccount {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on CRTTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on CLTTrust {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on DonorAdvisedFund {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on PrivateFoundation {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on InsurancePersonalAccount {
      inEstateStatus
      stateInEstateStatus
      gstStatus
    }
    ... on BusinessEntity {
      grantorControlledValue
    }
  }
}
    ${EntityValuationActions_EntityFragmentDoc}`;